var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_1005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3046 14.8619L12.3253 10.8825C13.4097 9.55625 13.9429 7.86392 13.8145 6.15556C13.6862 4.44721 12.9061 2.85354 11.6357 1.7042C10.3653 0.554862 8.7017 -0.0622172 6.98907 -0.019396C5.27644 0.0234252 3.64578 0.72287 2.43439 1.93426C1.22299 3.14566 0.523547 4.77632 0.480726 6.48895C0.437905 8.20158 1.05498 9.86516 2.20432 11.1356C3.35366 12.406 4.94733 13.1861 6.65568 13.3144C8.36404 13.4428 10.0564 12.9096 11.3826 11.8252L15.362 15.8045C15.4877 15.926 15.6561 15.9932 15.8309 15.9916C16.0057 15.9901 16.1729 15.92 16.2965 15.7964C16.4201 15.6728 16.4902 15.5056 16.4918 15.3308C16.4933 15.156 16.4261 14.9876 16.3046 14.8619ZM7.16664 11.9999C6.11181 11.9999 5.08066 11.6871 4.2036 11.101C3.32654 10.515 2.64295 9.68204 2.23929 8.7075C1.83562 7.73296 1.73 6.6606 1.93579 5.62604C2.14158 4.59147 2.64953 3.64117 3.39541 2.89529C4.14129 2.14941 5.0916 1.64145 6.12616 1.43567C7.16073 1.22988 8.23308 1.3355 9.20762 1.73916C10.1822 2.14283 11.0151 2.82642 11.6011 3.70348C12.1872 4.58054 12.5 5.61169 12.5 6.66652C12.4984 8.08052 11.936 9.43615 10.9361 10.436C9.93628 11.4359 8.58064 11.9983 7.16664 11.9999Z",
    fill: "#B0B0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_1005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeachIcon);
export default __webpack_public_path__ + "static/media/SeachIcon.0af3ee1be4be3007b796652e4b77c043.svg";
export { ForwardRef as ReactComponent };